/** Alle Texte der Seite. Quelle: Maxikarte „26_392 FOM Konferenz Sicherheit & Verteidigung“
 *  (Name seit 06.10.2026: „FOM Live-Talk“).
 *  Textänderungen hier, nicht in den Komponenten. */

export const konferenz = {
  marke: 'FOM Live-Talk',
  format: 'Online-Event',
  formatHinweis: 'Sie nehmen per Livestream teil – egal, wo Sie gerade sind.',
  titel: ['Sicherheit &', 'Verteidigung', 'im Wandel'],
  unterzeile: 'Impulse für Netzwerke, resiliente Lieferketten und bedarfsgerechte Qualifizierung',
  datum: '25. November 2026',
  datumKurz: '25.11.2026',
  uhrzeit: '18.00 – 19.30 Uhr',
  // Muss zu datum/uhrzeit passen - ein Test prüft das. Im November gilt MEZ (UTC+1).
  beginnUtc: '2026-11-25T17:00:00Z',
  endeUtc: '2026-11-25T18:30:00Z',
  ort: 'Live gesendet aus den FOM Studios in Essen',
}

/** Haupttext neben der Karte - Wortlaut vom 06.10.2026 (Word-Vorlage „Haupttext und Karte“).
 *  [Text](Adresse) wird als Verweis gesetzt, **Text** fett. */
export const einleitung = {
  etikett: 'Wirtschaft, Wissenschaft & Verbände',
  titel: 'Sicherheit gemeinsam neu denken',
  absaetze: [
    'Die neue Sicherheitslage verlangt eine leistungsfähige Sicherheits- und Verteidigungsindustrie. '
      + 'Dafür müssen Produktionskapazitäten wachsen, Lieferketten widerstandsfähiger und neue Unternehmen in '
      + 'bestehende Strukturen eingebunden werden. Gleichzeitig braucht die Branche qualifizierte Fach- und '
      + 'Führungskräfte, um diesen Wandel langfristig zu gestalten.',
    'Der FOM Live-Talk, ausgerichtet von der [FOM Hochschule](https://www.fom.de) in Kooperation mit Defence.NRW, '
      + 'dem Bundesverband der Deutschen Sicherheits- und Verteidigungsindustrie (BDSV) und dem Bundesverband '
      + 'Materialwirtschaft, Einkauf und Logistik (BME), bringt Perspektiven aus Wirtschaft, Wissenschaft und '
      + 'Verbänden zusammen.',
  ],
}

export type ThemenSymbol = 'netz' | 'kette' | 'qualifizierung'

export const themen: { titel: string; text: string; symbol: ThemenSymbol }[] = [
  { titel: 'Starke Netzwerke', text: 'Nutzen, Risiken und Gestaltungsmöglichkeiten neuer Kooperationen', symbol: 'netz' },
  { titel: 'Resiliente Lieferketten', text: 'Digitalisierung, Transparenz und Versorgungssicherheit', symbol: 'kette' },
  { titel: 'Zukunftsfähige Qualifizierung', text: 'Kompetenzbedarfe und attraktive Bildungsangebote für die Branche', symbol: 'qualifizierung' },
]

export const themenAbschnitt = {
  etikett: 'Diskussionsthemen',
  titel: 'Worüber wir sprechen',
}

export const lagebild = {
  // Quelle der Punkte: FOM-Marktanalyse Sicherheit & Verteidigung (185 Unternehmen, Stand 15.07.2026), nur Orte
  kartenText: 'Standorte von Unternehmen der Sicherheits- und Verteidigungsindustrie in Deutschland (Auswahl).',
}

export interface Speaker {
  name: string
  funktion: string
  /** Pfad unter public/, z. B. '/img/speaker/mustermann.jpg' (Hochformat 0,866 : 1, Gesicht mittig).
   *  Fehlt das Bild, zeigt die Karte eine Silhouette. */
  bild?: string
  /** Herkunft des Fotos - nur zur Nachverfolgung, wird nicht angezeigt */
  quelle?: string
  /** Vorstellungstext für die Rückseite der Flip-Card (Wortlaut 07.10.2026) */
  text?: string
  /** Bildrechte - wird auf der Seite im Fotonachweis unter den Speakern genannt */
  copyright?: string
  /** nimmt online teil, nicht im Studio - erscheint als „Online zugeschaltet“ */
  zugeschaltet?: boolean
}

export const speakerAbschnitt = {
  etikett: 'Auf dem Podium',
  titel: 'Stimmen aus Wirtschaft, Wissenschaft und Verbänden',
  grusswort: 'Video-Grußwort', // wird zu Beginn eingespielt (Rossel 16.10., Marvin 20.10.2026)
  moderation: 'Moderation',
  mehr: 'Mehr erfahren',
  zurueck: 'Zurück',
  fotonachweis: 'Fotos',
  zugeschaltet: 'Online zugeschaltet',
}

/** Liste vom 06.10.2026. Fotos: offizielle Porträts der Personen bzw. ihrer Organisationen -
 *  Nutzungsrechte vor dem Livegang klären (siehe CLAUDE.md). */
export const grusswort: Speaker = {
  name: 'Mona Neubaur',
  funktion: 'Ministerin für Wirtschaft, Industrie, Klimaschutz und Energie und stellvertretende Ministerpräsidentin des Landes Nordrhein-Westfalen',
  bild: '/img/speaker/neubaur.jpg',
  quelle: 'https://www.wirtschaft.nrw/ministerium/ministerin-mona-neubaur',
}

/** NRW-Landeswappen neben dem Grußwort - ausgeschnitten aus dem Ministeriumslogo
 *  (wirtschaft.nrw/themes/custom/wirtschaft/logo.svg). Wappennutzung mit dem Ministerium abstimmen. */
export const grusswortLogo = { datei: '/partner/nrw-wappen.png', name: 'Landeswappen Nordrhein-Westfalen' }

/** Moderation (07.10.2026). PLATZHALTER Funktion: aus seinem öffentlichen Profil (Journalist, früher Hamburg 1 und ARD,
 *  Medientrainer „Interviewhelden“) - Bezeichnung mit ihm abstimmen. Foto nur 300 px öffentlich. */
export const moderation: Speaker = {
  name: 'Markus Tirok',
  funktion: 'Journalist, Moderator und Medientrainer',
  bild: '/img/speaker/tirok.jpg',
  quelle: 'https://www.campixx.de/experten/tirok-markus/ (Speaker-Porträt, 300 px)',
}

// Herkunft der offiziellen Speakerfotos und -funktionen
const QUELLE_ASANA = 'Asana „Fotos, Namen und Funktionen“ (Nils Jewko, 08.10.2026)'

export const speaker: Speaker[] = [
  {
    name: 'Dr. Hans Christoph Atzpodien',
    // Text: Prof. Russack, Mail 19.10.2026 – endet dort mit „… ein und“ (abgebrochen?), „langjährigen“ grammatisch angepasst. Rückfrage offen.
    text: 'Dr. Hans Christoph Atzpodien bringt seine langjährigen Industrie- und BDSV-Erfahrungen zu den Themen Vergabe und Beschaffung, Unternehmensnetzwerke und Rahmenbedingungen in der SVI in die Diskussion ein.',
    funktion: 'Hauptgeschäftsführer Bundesverband der Deutschen Sicherheits- und Verteidigungsindustrie (BDSV) e.V.',
    bild: '/img/speaker/atzpodien.jpg',
    quelle: QUELLE_ASANA,
  },
  {
    name: 'Dr. Lars Kleeberg',
    // Text: Prof. Russack, Mail 19.10.2026
    text: 'Dr. Lars Kleeberg, Hauptgeschäftsführer des BME, beleuchtet die Bedeutung von Einkauf, Supply Chain Management und Logistik für resiliente Lieferketten – u. a. im Kontext der strategischen, digitalen Vernetzungsplattform SVI-Connect.',
    funktion: 'Hauptgeschäftsführer Bundesverband Materialwirtschaft, Einkauf und Logistik e.V. (BME)',
    bild: '/img/speaker/kleeberg.jpg',
    quelle: QUELLE_ASANA,
    copyright: 'Yvonne Most / BME',
  },
  {
    name: 'Dr. Lino Schneider-Bertenburg',
    // Text: Prof. Russack, Mail 19.10.2026
    text: 'Dr. Lino Schneider-Bertenburg bringt als Clustermanager von Defence.NRW die Perspektive der Vernetzung von Industrie, Start-up-Szene, Forschung und staatlicher Ebene ein.',
    funktion: 'Clustermanager Defence.NRW',
    bild: '/img/speaker/schneider-bertenburg.jpg',
    quelle: QUELLE_ASANA + ' - Original nur 570 px',
    copyright: 'VDI Technologiezentrum GmbH',
  },
  // Zugeschaltet (15.10.2026, Mail von Prof. Russack über Christian Gierke). Funktion: Signatur seiner Assistentin
  // und BME-Symposium 2025 („Chief Purchasing Officer, Rheinmetall AG“). Vorstellungstext: eigener Entwurf, abstimmen.
  {
    name: 'Marcus Gerlach',
    text: 'Marcus Gerlach verantwortet als Chief Purchasing Officer den konzernweiten Einkauf der Rheinmetall AG und bringt die Industrieperspektive auf Lieferketten, Zulieferer und den Hochlauf der Produktion ein.',
    // geschütztes Leerzeichen, damit „AG“ nicht allein in die zweite Zeile rutscht
    funktion: 'Chief Purchasing Officer, Rheinmetall AG',
    bild: '/img/speaker/gerlach.jpg',
    quelle: 'Mail Prof. Russack, 15.10.2026 (Foto über Rheinmetall, 21-05-19 Marcus Gerlach_3988.jpg)',
    copyright: 'Fotostudio M42',
    zugeschaltet: true, // Marvin 20.10.2026: „Gerlach ist online zugeschaltet“
  },
  {
    name: 'Dennis Nejdrowski',
    text: 'Dennis Nejdrowski bringt als Geschäftsführer der iesy GmbH die Unternehmensperspektive sowie Expertise zu Netzwerken, Lieferketten und systemkritischen Anwendungen ein.',
    funktion: 'Geschäftsführer iesy GmbH',
    bild: '/img/speaker/nejdrowski.jpg',
    quelle: QUELLE_ASANA,
  },
  // Zugeschaltet (15.10.2026). Name und Funktion aus seiner Signatur; Institutsleiter seit 15.08.2026 (Doppelspitze
  // mit Prof. Peter Martini), vorher u. a. Forschungsdirektor der Cyberagentur (esut.de, 17.08.2026).
  // Vorstellungstext: eigener Entwurf, abstimmen.
  {
    name: 'Prof. Dr. habil. Christoph Igel',
    text: 'Prof. Dr. habil. Christoph Igel bringt als Institutsleiter des Fraunhofer FKIE und früherer Forschungsdirektor der Cyberagentur die Perspektive der wehrtechnischen Forschung auf Innovation, Digitalisierung und Verteidigungsfähigkeit ein.',
    funktion: 'Institutsleiter Fraunhofer-Institut für Kommunikation, Informationsverarbeitung und Ergonomie FKIE',
    bild: '/img/speaker/igel.jpg',
    quelle: 'Mail Prof. Igel an Prof. Russack, 15.10.2026, „zum Zweck der Veranstaltungsankündigung“ (FKIE_CIgel_60x40mm.jpg, Rand gespiegelt ergänzt)',
    copyright: 'Petra Kaiser / Fraunhofer FKIE',
  },
  {
    name: 'Prof. Dr.-Ing. Thomas Russack',
    // Text: Prof. Russack, Mail 19.10.2026
    text: 'Prof. Dr.-Ing. Thomas Russack bringt als Leiter des Instituts für Automatisierung & Industrielles Management die Perspektive der angewandten Produktions- und Organisationsforschung ein und beleuchtet Kompetenzanforderungen sowie Qualifizierungsbedarfe.',
    funktion: 'Dekan des Hochschulbereichs Ingenieurwesen, FOM Hochschule',
    bild: '/img/speaker/russack.jpg',
    quelle: QUELLE_ASANA,
  },
]

/** „Für wen ist der Live-Talk?“ - Wortlaut vom 06.10.2026 (Word-Vorlage). Reine Darstellung, keine Auswahl. */
export const zielgruppenAbschnitt = {
  etikett: 'Für wen ist der Live-Talk?',
  titel: 'Für Entscheider und Fachkräfte aus Sicherheit und Verteidigung',
}

export const zielgruppen: { gruppe: string; eintraege: string[] }[] = [
  {
    gruppe: 'Unternehmen & Verbände',
    eintraege: [
      'Sicherheits- und Verteidigungsindustrie',
      'Zulieferer & Dual-Use-Unternehmen',
      'Verbände & Interessenvertretungen',
      'Forschung & Hochschulen',
      'Medien',
    ],
  },
  {
    gruppe: 'Funktionen & Verantwortungsbereiche',
    eintraege: [
      'Geschäftsführung & Führungskräfte',
      'Einkauf & Beschaffung',
      'Supply Chain Management',
      'Personal & Qualifizierung',
      'Journalisten',
    ],
  },
]

/** Auswahllisten im Anmeldeformular (optional) - dieselben Einträge wie „Für wen ist der Live-Talk?“ */
export const branchen = zielgruppen[0].eintraege
// „Student | Alumni“ nur im Formular, nicht im Abschnitt „Für wen“ (Wunsch 06.10.2026)
export const funktionen = [...zielgruppen[1].eintraege, 'Student | Alumni']

export const studio = {
  titel: 'Live gesendet aus den FOM Studios in Essen',
}

export const partner: { name: string; logo: string; breite: number; hoehe: number }[] = [
  // PLATZHALTER: DEFENCE.NRW und BME aus der Karte ausgeschnitten (niedrige Auflösung) - Originale anfordern.
  // BDSV: Original-Vektorlogo vom BDSV (EPS, 13.10.2026)
  { name: 'DEFENCE.NRW', logo: '/partner/defence-nrw.png', breite: 582, hoehe: 230 },
  { name: 'BDSV – Bundesverband der Deutschen Sicherheits- und Verteidigungsindustrie', logo: '/partner/bdsv.svg', breite: 163, hoehe: 64 },
  { name: 'BME – Bundesverband Materialwirtschaft, Einkauf und Logistik', logo: '/partner/bme.png', breite: 692, hoehe: 128 },
]

export const anmeldung = {
  etikett: 'Anmeldung',
  titel: 'Seien Sie live dabei',
  text: 'Melden Sie sich jetzt an und sichern Sie sich Ihren Zugang zum FOM Live-Talk.',
  knopf: 'Jetzt anmelden',
  danke: 'Vielen Dank für Ihre Anmeldung',
  // PLATZHALTER: mit dem Veranstaltungsteam bestätigen, wie der Zugang verschickt wird.
  dankeText: 'Wir senden Ihnen rechtzeitig vor dem Live-Talk den Zugang zum Livestream.',
}

/** Seite /vor-ort: 30 Plätze in den FOM Studios, nur über den persönlichen Link aus der Einladung
 *  (Entwurf 15.10.2026, Texte mit Marvin abstimmen). Keine Platzanzahl nennen.
 *  Werte mit PLATZHALTER_PREFIX werden auf der Seite und im PDF sichtbar als Platzhalter markiert,
 *  bis Marvin die Angaben nachreicht. */
export const PLATZHALTER_PREFIX = 'PLATZHALTER: '

export const vorOrt = {
  marke: 'Persönliche Einladung',
  format: 'Vor Ort in den FOM Studios',
  formatKurz: 'Vor Ort',
  einladung: [
    'wir freuen uns, Sie persönlich zum FOM Live-Talk „Sicherheit & Verteidigung im Wandel“ einzuladen – '
      + 'nicht vor dem Bildschirm, sondern direkt bei uns in den FOM Studios in Essen.',
    'Für Gäste vor Ort halten wir eine begrenzte Zahl an Plätzen bereit. Erleben Sie die Diskussion '
      + 'aus nächster Nähe.',
  ],
  ohneAnrede: 'Guten Tag,',
  knopf: 'Teilnahme vor Ort bestätigen',
  knopfKurz: 'Teilnehmen',
  pdfKnopf: 'Programm als PDF',
  pdf: '/vor-ort/FOM-Live-Talk-Sicherheit-Verteidigung-Programm.pdf',
}

export const vorOrtAblauf = {
  etikett: 'Ihr Abend vor Ort',
  titel: 'Ablauf, Anfahrt und Ansprechpersonen',
  // Angaben der Studioproduktion (Sandra Wolf, Mail 20.10.2026)
  programm: [
    { zeit: '17.30 Uhr', text: 'Türöffnung – Zeit für Garderobe und ein erstes Getränk' },
    { zeit: '17.40 Uhr', text: 'Einlass ins Studio mit kurzer Einweisung' },
    { zeit: '17.55 Uhr', text: 'Wir gehen live' },
    { zeit: '18.00 Uhr', text: 'Beginn des Live-Talks mit dem Video-Grußwort' },
    { zeit: '19.30 Uhr', text: 'Ende des Live-Talks' },
    { zeit: 'Im Anschluss', text: 'Buffet, Getränke und Zeit zum Networking' },
  ],
  ort: {
    titel: 'So finden Sie uns',
    name: 'FOM Studios',
    adresse: 'Sigsfeldstraße 5, 45141 Essen',
    // intern (nicht veröffentlichen): Besucherparkplätze vor dem Haus sind für die Gäste auf dem Podium reserviert
    anfahrt: 'Auf dem Gelände der FOM Hochschule steht nur eine begrenzte Zahl an Parkplätzen zur Verfügung. '
      + 'Bitte nutzen Sie deshalb auch die öffentlichen Parkplätze in der Umgebung.',
  },
  kontakt: {
    titel: 'Ihre Ansprechpersonen vor Ort',
    // geschützte Leerzeichen: Vor- und Nachname nie getrennt
    name: 'Carsten\u00A0Isherwood und Sandra\u00A0Wolf',
    erreichbar: 'studioproduktionen@fom.de',
    hinweis: 'Falls Sie doch nicht teilnehmen können, geben Sie uns bitte kurz Bescheid.',
  },
  aufzeichnung: 'Der Live-Talk wird aufgezeichnet und live übertragen. Gäste vor Ort können dabei im Bild zu sehen sein.',
}

export const vorOrtAnmeldung = {
  etikett: 'Anmeldung vor Ort',
  titel: 'Ihr Platz in den FOM Studios',
  text: 'Ihre Angaben haben wir aus der Einladung übernommen. Bitte prüfen Sie sie kurz und bestätigen Sie Ihre Teilnahme.',
  label: 'Teilnahme vor Ort am FOM Live-Talk bestätigen',
  danke: 'Vielen Dank für Ihre Anmeldung',
  dankeText: 'Ihre Anmeldung zur Teilnahme vor Ort ist bei uns eingegangen. Sie hören in Kürze per E-Mail von uns.',
  ohneLink: 'Die Anmeldung vor Ort ist nur über den persönlichen Link aus Ihrer Einladung möglich. '
    + 'Bitte öffnen Sie die Seite über diesen Link.',
  ungueltig: 'Dieser Einladungslink ist nicht gültig. Bitte nutzen Sie den Link aus Ihrer Einladung '
    + 'oder wenden Sie sich an uns.',
  laedt: 'Ihre Einladung wird geladen …',
  // Vertretung (Wunsch Frau Appel, 16.10.2026): wer nicht selbst kommen kann, schlägt eine Person vor
  wahlSelbst: 'Ich nehme selbst teil',
  wahlVertretung: 'Ich kann nicht teilnehmen und schlage eine Vertretung vor',
  vertretungHinweis: 'Nennen Sie uns gern eine Person aus Ihrem Haus, die an Ihrer Stelle teilnehmen kann. Wir laden sie dann persönlich ein.',
  vertretungDatenschutz: 'Wir nutzen diese Angaben nur, um Ihre Vertretung zum FOM Live-Talk einzuladen.',
  vertretungKnopf: 'Vertretung vorschlagen',
  vertretungDanke: 'Vielen Dank für Ihren Vorschlag',
  vertretungDankeText: 'Wir melden uns mit einer persönlichen Einladung bei Ihrer Vertretung.',
}
